import React, { lazy } from "react";

const LazyJeAccrualBatchMetadata = lazy(
  () => import("./JeAccrualBatchMetadata")
);

const JeAccrualBatchMetadata = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyJeAccrualBatchMetadata {...props} />;

export default JeAccrualBatchMetadata;
